import { Action } from 'redux';
import { IAppState } from '../../../state/reducers';

export enum ActionType {
  UpdatePlayerReady = 'VideoPlayer.UpdatePlayerReady',
  UpdateIsPlaying = 'VideoPlayer.UpdateIsPlaying',
  UpdateCurrentTime = 'VideoPlayer.UpdateCurrentTime',
  UpdateIsSeeking = 'VideoPlayer.UpdateIsSeeking',
  EnableClipperKeyboardControls = 'VideoPlayer.EnableClipperKeyboardControls',
  DisableClipperKeyboardControls = 'VideoPlayer.DisableClipperKeyboardControls',
}

export interface IVideoPlayerAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  isReady: boolean;
  isPlaying: boolean;
  isSeeking: boolean;
  isKeyboardControlsEnabled: boolean;
  currentTime: number;
}

const INITIAL_STATE: IState = {
  isReady: false,
  isPlaying: false,
  isSeeking: false,
  isKeyboardControlsEnabled: true,
  currentTime: 0,
};

export default function reducer(state = INITIAL_STATE, action: IVideoPlayerAction) {
  switch (action.type) {
    case ActionType.UpdatePlayerReady:
      return {
        ...state,
        isReady: action.payload,
      };
    case ActionType.UpdateIsPlaying:
      return {
        ...state,
        isPlaying: action.payload,
      };
    case ActionType.UpdateCurrentTime:
      return {
        ...state,
        currentTime: action.payload,
      };
    case ActionType.UpdateIsSeeking:
      return {
        ...state,
        isSeeking: action.payload,
      };
    case ActionType.EnableClipperKeyboardControls:
      return {
        ...state,
        isKeyboardControlsEnabled: true,
      };
    case ActionType.DisableClipperKeyboardControls:
      return {
        ...state,
        isKeyboardControlsEnabled: false,
      };
    default:
      return state;
  }
}

export const updatePlayerReady = (isPlayerReady: boolean) => ({
  type: ActionType.UpdatePlayerReady,
  payload: isPlayerReady,
});

export const updateIsPlaying = (isPlaying: boolean) => ({
  type: ActionType.UpdateIsPlaying,
  payload: isPlaying,
});

export const updateCurrentTime = (currentTime: number) => ({
  type: ActionType.UpdateCurrentTime,
  payload: currentTime,
});

export const updateIsSeeking = (isSeeking: boolean) => ({
  type: ActionType.UpdateIsSeeking,
  payload: isSeeking,
});

export const enableClipperKeyboardControls = () => ({
  type: ActionType.EnableClipperKeyboardControls,
});

export const disableClipperKeyboardControls = () => ({
  type: ActionType.DisableClipperKeyboardControls,
});

export const selectCurrentTime = (state: IAppState) => (
  Number(state.videoPlayer.currentTime.toFixed(2))
);
